import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { BlocCompétences } from '../croisement-référentiel/models/bloc-compétences';

@Injectable({
  providedIn: 'root',
})
export class BlocCompétencesService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/blocs-compétences';

  parCodeBloc = (code: string, idReferentiel: string) => {
    let params = new HttpParams().append('idReferentiel', idReferentiel);

    return this.#http.get<BlocCompétences>(this.BASE_URL + '/' + code, { params });
  };

  modifier = (bloc: BlocCompétences, idReferentiel: string) => {
    let params = new HttpParams().append('idReferentiel', idReferentiel);

    return this.#http.put<void>(this.BASE_URL + '/' + bloc.id, bloc, { params });
  };
}
